
import {Component, Watch, Prop} from 'vue-property-decorator'
import draggable from 'vuedraggable'
import {Action, Getter, namespace} from 'vuex-class'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import SelectRef from '@/components/common/SelectRef.vue'
import PropositionModel from '@/models/PropositionModel'
import convertDateDirective from '@/directives/convertDateDirective'
import {required, decimal} from 'vuelidate/lib/validators'
import {isCoprolibDate} from '@/helpers/validators'
import RadioGroupYesNo from '@/components/common/RadioGroupYesNo.vue'
import CheckboxYesNo from '@/components/common/CheckboxYesNo.vue'

const configModule = namespace('config')

@Component({
  components: {
    draggable,
    BaseFormContainer,
    RadioGroupYesNo,
    CheckboxYesNo,
    SelectRef
  },
  directives: {
    convertDateDirective
  },
  validations: {
    form: {
      DATE_ENVOI_COMMANDE: {
        isCoprolibDate
      },
      DATE_RECEPTION_COMMANDE: {
        isCoprolibDate
      },
      DATE_VALIDITE: {
        isCoprolibDate
      },
      PROPOSITION_TARIF_UNITAIRE: {
        required,
        decimal
      },
      TARIF_REMISE_UNITAIRE: {
        decimal
      },
      TARIF_REMISE_GLOBAL: {
        decimal
      }
    },
    options: {
      $each: {
        CODE_REF_TYPE_OPTION: {
          required
        },
        LIBELLE: {
          required
        },
        TARIF: {
          required,
          decimal
        },
        NB_CREDITS_OPTION_PAC: {}
      }
    }
  }
})
export default class PropositionForm extends BaseForm {
  @configModule.Action('getPropositionOptionsAction') getPropositionOptions: any
  @configModule.Getter('propositionOptionsGetter') propositionOptions: any
  @Prop(Object) prospect!: any
  @Prop(Array) offre!: any
  @Prop(Array) typeRemise!: any
  model = PropositionModel
  options = []
  selectOption = ''

  @Watch('form.CODE_REF_OFFRE', {deep: false})
  watchFormPropositionType(val: any) {
    if (this.prospect) {
      this.setDefaultPrice()
    }
  }

  @Watch('form.OPTIONS', {deep: false})
  watchFormOptions(val: any, oldVal: any) {
    if (!oldVal && val) {
      this.options = val.map((item) => {
        return {
          CODE_REF_TYPE_OPTION: item.CODE_REF_TYPE_OPTION,
          LIBELLE: item.LIBELLE,
          TARIF: item.TARIF,
          TEXTE: item.TEXTE,
          FORCEE: item.FORCEE,
          NB_CREDITS_OPTION_PAC: item.NB_CREDITS_OPTION_PAC
        }
      })
    }
  }

  @Watch('prospect', {deep: true})
  watchProspect(val: any) {
    if (val) {
      this.setDefaultPrice()
      this.setdefaultPropositionAssemblee()
    }
  }

  @Watch('selectOption', {deep: true})
  watchSelectOption(val: any) {
    if (val && val !== '') {
      this.addOption(val)
    }
  }

  @Watch('options', {deep: true})
  watchOptions(val: any) {
    if (val) {
      this.form.OPTIONS = val
    }
  }

  get isTarifNegocie() {
    return this.form.TARIF_NEGOCIE
  }

  get isTypeLogiciel() {
    return this.form.CODE_REF_OFFRE === 'A'
  }

  get isTypeAssistanceIncluse() {
    return this.form.CODE_REF_OFFRE === 'AS'
  }

  get isTypeSerenite() {
    return this.form.CODE_REF_OFFRE === 'S'
  }

  get isTypeProximite() {
    return this.form.CODE_REF_OFFRE === 'P'
  }

  get isTypePrestation() {
    return this.form.CODE_REF_OFFRE === 'X'
  }

  get isTypeConseilSyndical() {
    return this.form.CODE_REF_OFFRE === 'CS'
  }

  mounted() {
    this.getPropositionOptions()
    if (this.prospect) {
      this.setDefaultPrice()
      this.setdefaultPropositionAssemblee()
    }
  }

  resetOptionsAutonomie() {
    this.form.PROPOSITION_SECRETARIAT = 0
    this.form.PROPOSITION_COACHING = 0
  }

  resetOptions() {
    this.form.PROPOSITION_EMPLOYES = 0
    this.form.PROPOSITION_AUDIT = 0
    this.form.PROPOSITION_DEMARRAGE = 0
  }

  setdefaultPropositionAssemblee() {
    const nombreLotsPrincipaux = this.prospect.NOMBRE_LOTS_PRINCIPAUX
    if (nombreLotsPrincipaux <= 15) {
      this.form.PROPOSITION_TENUE_ASSEMBLEES = 0
    } else {
      this.form.PROPOSITION_TENUE_ASSEMBLEES = 1
    }
  }

  setDefaultPrice() {
    const codeRefTypeEntite = this.prospect.CODE_REF_TYPE_ENTITE
    const nombreLotsPrincipaux = this.prospect.NOMBRE_LOTS_PRINCIPAUX
    // Autonomie
    if (this.isTypeLogiciel || this.isTypeAssistanceIncluse) {
      if (codeRefTypeEntite && codeRefTypeEntite === 'C') {
        if (this.isTypeAssistanceIncluse) {
          this.form.PROPOSITION_TARIF_UNITAIRE = 7
        } else {
          this.form.PROPOSITION_TARIF_UNITAIRE = 4
        }
      } else if (codeRefTypeEntite && codeRefTypeEntite === 'A') {
        if (nombreLotsPrincipaux) {
          if (parseInt(nombreLotsPrincipaux) < 30) {
            if (this.isTypeAssistanceIncluse) {
              this.form.PROPOSITION_TARIF_UNITAIRE = 7
            } else {
              this.form.PROPOSITION_TARIF_UNITAIRE = 4
            }
          }
          if (parseInt(nombreLotsPrincipaux) >= 30) {
            if (this.isTypeAssistanceIncluse) {
              this.form.PROPOSITION_TARIF_UNITAIRE = 5
            } else {
              this.form.PROPOSITION_TARIF_UNITAIRE = 2
            }
          }
        } else {
          if (this.isTypeAssistanceIncluse) {
            this.form.PROPOSITION_TARIF_UNITAIRE = 7
          } else {
            this.form.PROPOSITION_TARIF_UNITAIRE = 4
          }
        }
      } else {
        this.form.PROPOSITION_TARIF_UNITAIRE = 4
      }
      this.formDefault.PROPOSITION_TARIF_UNITAIRE = this.form.PROPOSITION_TARIF_UNITAIRE
    }
    // Serenite
    if (this.isTypeSerenite) {
      this.resetOptionsAutonomie()
      if (nombreLotsPrincipaux) {
        if (parseInt(nombreLotsPrincipaux) < 100) {
          this.form.PROPOSITION_TARIF_UNITAIRE = 10
        }
        if (parseInt(nombreLotsPrincipaux) >= 100) {
          this.form.PROPOSITION_TARIF_UNITAIRE = 7
        }
      } else {
        this.form.PROPOSITION_TARIF_UNITAIRE = 10
      }
      this.formDefault.PROPOSITION_TARIF_UNITAIRE = this.form.PROPOSITION_TARIF_UNITAIRE
    }
    // Proximite
    if (this.isTypeProximite) {
      this.resetOptionsAutonomie()
      if (nombreLotsPrincipaux) {
        if (parseInt(nombreLotsPrincipaux) < 20) {
          this.form.PROPOSITION_TARIF_UNITAIRE = 12
        }
        if (parseInt(nombreLotsPrincipaux) >= 20 && parseInt(nombreLotsPrincipaux) < 100) {
          this.form.PROPOSITION_TARIF_UNITAIRE = 11
        }
        if (parseInt(nombreLotsPrincipaux) > 100) {
          this.form.PROPOSITION_TARIF_UNITAIRE = 10
        }
      } else {
        this.form.PROPOSITION_TARIF_UNITAIRE = 12
      }
      this.formDefault.PROPOSITION_TARIF_UNITAIRE = this.form.PROPOSITION_TARIF_UNITAIRE
    }
    // Prestation
    if (this.isTypePrestation) {
      this.resetOptionsAutonomie()
      this.resetOptions()
    }
  }

  addOption(item = null) {
    if (item) {
      const {CODE_REF_TYPE_OPTION, LIBELLE, TARIF, TEXTE, FORCEE, NB_CREDITS_OPTION_PAC} = item
      this.options.push({
        CODE_REF_TYPE_OPTION,
        LIBELLE,
        TARIF: String(TARIF),
        TEXTE,
        FORCEE,
        NB_CREDITS_OPTION_PAC
      })
      this.selectOption = ''
    } else {
      this.options.push({
        CODE_REF_TYPE_OPTION: '',
        LIBELLE: '',
        TARIF: '',
        TEXTE: '',
        FORCEE: 0,
        NB_CREDITS_OPTION_PAC: ''
      })
    }
  }

  removeOption(index) {
    this.options.splice(index, 1)
  }
}
